<template>
  <div v-if="visible" class="conversation">
    <!-- Header -->
    <div class="conversation-header">
      <!-- <button @click="$emit('back')" class="back-btn">
        <svg style="min-width: 24px;height: 24px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button> -->

      <div class="user-info" @click="$emit('viewProfile', otherUser)">
        <div class="user-avatar">
          <img :src="!otherUser.profilImgMini1? require('./img/profile.svg') : imgBsrl+otherUser.profilImgMini1" />
          <div v-if="$store.state.onlineUserIds[otherUser.uid]" class="online-dot"></div>
        </div>
        <div class="user-details">
          <div class="user-name">{{ otherUser.name }}</div>
          <div class="user-status">
            <span v-if="$store.state.onlineUserIds[otherUser.uid]">Online</span>
            <span v-else>{{ lastSeenText }}</span>
          </div>
        </div>
      </div>

      <button @click="close" class="options-btn">
        <!-- <svg style="min-width: 24px;height: 24px;" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="5" r="2"/>
          <circle cx="12" cy="12" r="2"/>
          <circle cx="12" cy="19" r="2"/>
        </svg> -->
        <svg style="min-width: 24px;height: 24px;" width="800px" height="800px" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 5L4.99998 19M5.00001 5L19 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>

    <!-- Messages List -->
    <div class="messages-container" ref="messagesContainer" @scroll="handleScroll">
        <!-- LOADER SPINNER (TOP LEFT) - You control isLoadingOlderMessages yourself -->
        <div v-if="loading" class="messages-loader">
          <svg class="loader-spinner" viewBox="0 0 50 50">
            <circle 
              class="spinner-path" 
              cx="25" 
              cy="25" 
              r="20" 
              fill="none" 
              stroke-width="4"
            />
          </svg>
        </div>
            <!-- FLOATING DATE BUBBLE (TOP CENTER) -->
        
          <div class="floating-date-bubble-wrap">
            <transition name="date-bubble-fade">
              <span v-if="showDateBubble && currentVisibleDate" class="floating-date-bubble">{{ formattedVisibleDate }}</span>
            </transition>
          </div>

         <Message
          v-for="message in messages"
          :key="message._id"
          :message="message"
          :currentUserId="currentUserId"
          :allMessages="messages"
          :isLoading="message.isLoading || false"
          @scrollTo="scrollToMessage"
          @reply="handleReply"
          @edit="handleEdit"
          @delete="handleDelete"
          @viewImage="handleViewImage"
        />
      
      <!-- Typing Indicator -->
      <div v-if="isTyping" class="typing-indicator">
        <div class="typing-dot"></div>
        <div class="typing-dot"></div>
        <div class="typing-dot"></div>
      </div>
    </div>

    <!-- Message Preview (when sending) -->
    <div v-if="sendingPreview" class="sending-preview">
      <div class="preview-content">
        <div class="spinner"></div>
        <span>Sending...</span>
      </div>
    </div>

    <!-- Reply Bar -->
    <div v-if="replyingTo" class="reply-bar">
      <div class="reply-info">
        <div class="reply-label">Replying to {{ replyingTo.senderId === currentUserId ? 'yourself' : otherUser.name }}</div>
        <div class="reply-preview-text">{{ getMessagePreview(replyingTo) }}</div>
      </div>
      <button @click="cancelReply" class="cancel-reply-btn">
        <svg style="min-width: 24px;height: 24px;"  viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <!-- Input Area -->
    <div class="input-area">
      <button @click="$refs.imageInput.click()" class="attach-btn">
        <svg style="min-width: 24px;height: 24px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
          <circle cx="8.5" cy="8.5" r="1.5"/>
          <polyline points="21 15 16 10 5 21"/>
        </svg>
      </button>
      <input ref="imageInput" type="file" accept="image/*" @change="handleImageSelect" style="display: none" />

      <button @click="toggleAudioRecording" :class="['audio-btn', { recording: isRecording }]">
        <svg style="min-width: 24px;height: 24px;" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
          <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
          <line x1="12" y1="19" x2="12" y2="23"/>
          <line x1="8" y1="23" x2="16" y2="23"/>
        </svg>
        <span v-if="isRecording" class="recording-time">{{ recordingTime }}s</span>
      </button>

      <input
        v-model="messageText"
        @keydown.enter="sendMessage"
        type="text"
        class="message-input"
        placeholder="Type a message..."
      />

      <button @click="sendMessage" class="send-btn" :disabled="!canSend">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="22" y1="2" x2="11" y2="13"/>
          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
      </button>
    </div>




    <!-- Image Preview Modal -->
<div v-if="showImagePreview" class="preview-modal">
  <div class="preview-overlay" @click="cancelImagePreview"></div>
  <div class="preview-content">
    <div class="preview-header">
      <h3>Send Photo</h3>
      <button @click="cancelImagePreview" class="close-btn">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
    <div class="preview-image-container">
      <img :src="selectedImagePreview" alt="Preview" />
    </div>
    <textarea
      v-model="imagePreviewText"
      class="preview-caption"
      placeholder="Add a caption..."
    ></textarea>
    <div class="preview-actions">
      <button @click="cancelImagePreview" class="preview-cancel-btn">Cancel</button>
      <button @click="sendImageMessage" class="preview-send-btn">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="22" y1="2" x2="11" y2="13"/>
          <polygon points="22 2 15 22 11 13 2 9 22 2"/>
        </svg>
        Send
      </button>
    </div>
  </div>
</div>

    <!-- Audio Preview Modal -->
    <div v-if="showAudioPreview" class="preview-modal">
      <div class="preview-overlay" @click="cancelAudioPreview"></div>
      <div class="preview-content audio-preview-content">
        <div class="preview-header">
          <h3>Send Audio</h3>
          <button @click="cancelAudioPreview" class="close-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div class="audio-preview-player">
          <audio :src="recordedAudioUrl" controls></audio>
          <div class="audio-duration">Duration: {{ recordingTime }}s</div>
        </div>
        <div class="preview-actions">
          <button @click="cancelAudioPreview" class="preview-cancel-btn">Cancel</button>
          <button @click="sendAudioMessage" class="preview-send-btn">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="22" y1="2" x2="11" y2="13"/>
              <polygon points="22 2 15 22 11 13 2 9 22 2"/>
            </svg>
            Send
          </button>
        </div>
      </div>
    </div>

    <!-- Edit Message Modal -->
    <div v-if="showEditModal" class="preview-modal">
      <div class="preview-overlay" @click="cancelEdit"></div>
      <div class="preview-content edit-modal-content">
        <div class="preview-header">
          <div>Edit Message</div>
          <button @click="cancelEdit" class="close-btn">
            <svg style="min-width: 24px;height: 24px;" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        
        <div class="edit-modal-body">
          
          <div class="edit-input-container">
            <textarea
              v-model="editText"
              ref="editTextarea"
              class="edit-textarea"
              placeholder="Type your message..."
              @keydown.enter.ctrl="submitEdit"
              @keydown.esc="cancelEdit"
            ></textarea>
          </div>
        </div>
        
        <div class="preview-actions">
          <button @click="cancelEdit" class="preview-cancel-btn">Cancel</button>
          <button @click="submitEdit" class="preview-send-btn" :disabled="!editText.trim()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
            Save
          </button>
        </div>
      </div>
    </div>
    <ImageViewer ref="imageViewer" :images="imageViewed" :imagesMini="[]" style="z-index: 2;"/>
  </div>
</template>




<script>
import Message from './Message.vue';
import ImageViewer from '@/views/components/ImageViewer.vue'
import { resolvePendingMessagesSequential } from '@/views/conversation/routine'

export default {
  name: 'Conversation',
  components: { Message,ImageViewer },
  data() {
    return {
      Display:true,
      imgBsrl:this.$store.state.baseUrl+'images/',
      messageText: '',
      selectedImage: null,
      selectedImagePreview: null,
      replyingTo: null,
      isRecording: false,
      recordingTime: 0,
      recordingTimer: null,
      mediaRecorder: null,
      audioChunks: [],
      recordedAudioBlob: null,
      recordedAudioUrl: null,
      sendingPreview: false,
      isTyping: false,
      showImagePreview: false,
      showAudioPreview: false,
      imagePreviewText: '',
      showEditModal: false,
      editingMessage: null,
      editText: '',
          // ADD THESE
      currentVisibleDate: null,
      showDateBubble: false,
      dateBubbleTimer: null,
      loading: false, // You'll control this yourself,
      imageViewed:[],
      allOldMessagesLoaded: false
    }
  },
  computed: {
    currentUserId() {
      return this.$store.state.user?.uid || 'currentUser';
    },
    otherUser () { return this.$store.state.chatSetting.otherUser},
    visible () {
      return this.$store.state.chatSetting.visible
    },
    messages() {
      return this.$store.state.messages[this.otherUser.uid] || [];
    },
    canSend() {
      return this.messageText.trim() || this.selectedImage || this.recordedAudioBlob;
    },
    lastSeenText() {
      if (!this.otherUser.lastSeen) return 'Last seen recently';
      
      const lastSeen = new Date(this.otherUser.lastSeen);
      const now = new Date();
      const diffMs = now - lastSeen;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);

      if (diffMins < 1) return 'Last seen just now';
      if (diffMins < 60) return `Last seen ${diffMins}m ago`;
      if (diffHours < 24) return `Last seen ${diffHours}h ago`;
      if (diffDays < 7) return `Last seen ${diffDays}d ago`;
      
      return 'Last seen recently';
    },
    // ADD THIS
    formattedVisibleDate() {
      if (!this.currentVisibleDate) return '';
      
      const date = new Date(this.currentVisibleDate);
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      
      // Reset time for comparison
      const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
      
      if (dateOnly.getTime() === todayOnly.getTime()) {
        return 'Today';
      } else if (dateOnly.getTime() === yesterdayOnly.getTime()) {
        return 'Yesterday';
      } else {
        return date.toLocaleDateString([], { 
          month: 'long', 
          day: 'numeric', 
          year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined 
        });
      }
    }
  },
  watch: {
    messages: {
      handler() {
        if(this.visible) this.markUnreadMessagesAsRead();
        this.$nextTick(() => {
          if(!this.loading /*preventing scrollBottom for getOldMessages*/)  this.scrollToBottom();
        });
      },
      deep: true
    },
    '$store.state.chatSetting.visible'(newVal) {
      if(!newVal) { // closing chat
        if (this.isRecording) {
          this.stopRecording();
        }
        if (this.recordedAudioUrl) {
          URL.revokeObjectURL(this.recordedAudioUrl);
        }
      }
      else {
        this.markUnreadMessagesAsRead();
        if (this.messages.length === 0) this.getOldMessages()
      }
    }
  },
  methods: {
  close () {
    this.$store.commit('closeChat')
  },
  async sendMessage() {
    if (!this.canSend) return;

    // Create pending message with loading state
    const pendingMessage = {
      _id: 'pending_' + Date.now(),
      chatId: this.generateChatId(this.currentUserId, this.userId),
      senderId: this.currentUserId,
      receiverId: this.userId,
      text: this.messageText.trim() || null,
      img: this.selectedImage ? URL.createObjectURL(this.selectedImage) : null,
      imgMini: null,
      audio: this.recordedAudioUrl || null,
      duration: this.recordingTime || null,
      callTime: null,
      replyingMessageId: this.replyingTo?._id || null,
      seenAt: null,
      createdAt: new Date(),
      deletedAt: null,
      modifiedAt: null,
      isLoading: true // Add loading flag
    };

    // Add to pending messages
    //this.pendingMessages.push(pendingMessage);
    //await new Promise(resolve => setTimeout(resolve, 5000));
    // Add real message to store
    this.$store.commit('addMessagesToConversation', {
      userId: this.otherUser.uid,
      messages: [pendingMessage]
    });

    resolvePendingMessagesSequential()

    this.resetForms()
  },
  resetForms () {
    // Reset form immediately
    this.messageText = '';
    this.selectedImage = null;
    this.selectedImagePreview = null;
    this.imagePreviewText = '';
    this.recordedAudioBlob = null;
    this.recordedAudioUrl = null;
    this.replyingTo = null;
    this.showImagePreview = false;
    this.showAudioPreview = false;
  },
    // ... (keep all other methods) ...

    handleEdit(message) {
      this.editingMessage = { ...message };
      this.editText = message.text || '';
      this.showEditModal = true;
    },

    cancelEdit() {
      this.editingMessage = null;
      this.editText = '';
      this.showEditModal = false;
    },

    async submitEdit() {
      if(!this.otherUser.uid) return
      if (!this.editText.trim() || this.editText === this.editingMessage.text) {
        this.cancelEdit();
        return;
      }
      let editText = this.editText
      const oldText = this.editingMessage.text
      let editingMessage = this.editingMessage
      this.cancelEdit()

      this.$store.commit('updateMessage', {
        userId: this.otherUser.uid,
        messageId: editingMessage._id,
        updates: {
          text: editText.trim(),
          modifiedAt: new Date(),
          isLoading:true,
          oldText:oldText
        }
      });

      resolvePendingMessagesSequential()

    },

    handleImageSelect(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.selectedImage = file;
      
      // Create preview URL
      const reader = new FileReader();
      reader.onload = (e) => {
        this.selectedImagePreview = e.target.result;
        this.showImagePreview = true;
      };
      reader.readAsDataURL(file);
    },

    cancelImagePreview() {
      this.selectedImage = null;
      this.selectedImagePreview = null;
      this.imagePreviewText = '';
      this.showImagePreview = false;
      this.$refs.imageInput.value = '';
    },

    sendImageMessage() {
      // Set text from image preview
      this.messageText = this.imagePreviewText;
      this.showImagePreview = false;
      this.sendMessage();
    },

    async toggleAudioRecording() {
      if (this.isRecording) {
        this.stopRecording();
      } else {
        await this.startRecording();
      }
    },

    async startRecording() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        this.mediaRecorder = new MediaRecorder(stream);
        this.audioChunks = [];
        this.recordingTime = 0;

        this.mediaRecorder.ondataavailable = (event) => {
          this.audioChunks.push(event.data);
        };

        this.mediaRecorder.onstop = () => {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/webm' });
          this.recordedAudioBlob = audioBlob;
          this.recordedAudioUrl = URL.createObjectURL(audioBlob);
          this.showAudioPreview = true;
        };

        this.mediaRecorder.start();
        this.isRecording = true;

        // Start timer
        this.recordingTimer = setInterval(() => {
          this.recordingTime++;
          if (this.recordingTime >= 60) {
            this.stopRecording();
          }
        }, 1000);

      } catch (error) {
        console.error('Error starting recording:', error);
        alert('Failed to access microphone');
      }
    },

    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.mediaRecorder.stream.getTracks().forEach(track => track.stop());
        this.isRecording = false;
        clearInterval(this.recordingTimer);
      }
    },

    cancelAudioPreview() {
      this.recordedAudioBlob = null;
      if (this.recordedAudioUrl) {
        URL.revokeObjectURL(this.recordedAudioUrl);
        this.recordedAudioUrl = null;
      }
      this.recordingTime = 0;
      this.showAudioPreview = false;
    },

    sendAudioMessage() {
      this.showAudioPreview = false;
      this.sendMessage();
    },

    handleReply(message) {
      this.replyingTo = message;
      this.$nextTick(() => {
        const input = this.$el.querySelector('.message-input');
        if (input) input.focus();
      });
    },

    cancelReply() {
      this.replyingTo = null;
    },

    async handleDelete(message) {
      if(!this.otherUser.uid) return
   
      this.$store.commit('updateMessage', {
        userId: this.otherUser.uid,
        messageId: message._id,
        updates: {
          deletedAt: new Date(),
          isLoading:true
        }
      });

      resolvePendingMessagesSequential()
    },

    scrollToMessage(messageId) {
      const element = document.getElementById(`message-${messageId}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.classList.add('highlight');
        setTimeout(() => {
          element.classList.remove('highlight');
        }, 2000);
      }
    },

    scrollToBottom() {
      if (this.$refs.messagesContainer) {
        this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
      }
    },

    handleViewImage(imageUrl) {
      this.imageViewed = [this.imgBsrl + imageUrl]
      this.$nextTick(()=>this.$refs.imageViewer.openViewer())
    },

    getMessagePreview(message) {
      if (message.text) return message.text;
      if (message.img) return '📷 Photo';
      if (message.audio) return '🎵 Audio';
      if (message.callTime !== null) return '📞 Call';
      return 'Message';
    },

    generateChatId(userId1, userId2) {
      return [userId1, userId2].sort().join('_');
    },
     // 5. HANDLE MESSAGES READ - UPDATE STORE
    handleMessagesRead(messageIds,receivedId) {
      const messages = this.$store.state.messages[receivedId];

      if(!messages) return
      const ids = messageIds || []
      // Update each message that was read
      ids.forEach(messageId => {
        const message = messages.find(m => m._id === messageId);
        
        if (message) {
          this.$store.commit('updateMessage', {
            userId: receivedId,
            messageId: messageId,
            updates: {
              seenAt: new Date()
            }
          });
        }
      });
    },
    getUnreadOtherUserMessageIds() {
      return this.messages
        .filter(msg => 
          msg.senderId === this.otherUser.uid && // From other user
          msg.receiverId === this.currentUserId && // To me
          !msg.seenAt && // Not seen
          !msg.deletedAt // Not deleted
        )
        .map(msg => msg._id);
    },
    // 2. MARK UNREAD MESSAGES AS READ
    markUnreadMessagesAsRead() {
      if(!this.otherUser.uid) return
      const unreadIds = this.getUnreadOtherUserMessageIds();
      console.log('unread message length------------',unreadIds.length)
      if (unreadIds.length === 0) return;
      
      this.$axios.post('/chat.php',{type:"seeMessages",
          messageIds:unreadIds,senderId:this.otherUser.uid})
      .then(() => {
        this.handleMessagesRead(unreadIds,this.otherUser.uid)
        // set all those messages to as swa
        console.log('Successfully marked messages as read');
      }).catch(err => {
        console.error('Error marking messages as read:', err);
      });
    },
    getOldMessages () {
      if(this.loading || this.allOldMessagesLoaded) return
      this.loading = true
      const userId = this.otherUser.uid
      this.$axios.post('/chat.php',{type:"chatListMessage", userId:userId,from:new Date()})
      .then(({data}) => {
        data = data || []
        console.log(data)
        // lets add the messages
        const k = this
        const numberOfMessages = this.messages.length 
        k.$store.commit('addMessagesToConversation', {
          userId: userId,
          messages: data
        });
        if(numberOfMessages === this.messages.length ) this.allOldMessagesLoaded = true
      }).catch(err => {
        console.error('loading message', err);
      })
      .finally ( ()=> {
        setTimeout(()=> this.loading = false, 500) // wait so that scrollBottom is avoided
      })
    },

    // HANDLE SCROLL - DETECT VISIBLE DATE
    handleScroll(event) {
      this.updateVisibleDate();
      
      const element = event.target

      if (element.scrollTop <= 5) {
        this.getOldMessages()
      }
    },
    
    updateVisibleDate() {
      const container = this.$refs.messagesContainer;
      if (!container) return;
      
      // Get all message elements
      const messageElements = container.querySelectorAll('.message');
      if (messageElements.length === 0) return;
      
      // Find the message at the top of the viewport
      const containerRect = container.getBoundingClientRect();
      const viewportTop = containerRect.top + 100; // Offset from top
      
      let closestMessage = null;
      let closestDistance = Infinity;
      
      messageElements.forEach((element, index) => {
        const rect = element.getBoundingClientRect();
        const distance = Math.abs(rect.top - viewportTop);
        
        if (distance < closestDistance && rect.top <= viewportTop + 50) {
          closestDistance = distance;
          closestMessage = { element, index };
        }
      });
      
      if (closestMessage) {
        const message = this.messages[closestMessage.index];
        if (message && message.createdAt) {
          this.currentVisibleDate = message.createdAt;
          this.showDateBubble = true;
          
          // Hide bubble after 2 seconds of no scrolling
          if (this.dateBubbleTimer) {
            clearTimeout(this.dateBubbleTimer);
          }
          this.dateBubbleTimer = setTimeout(() => {
            this.showDateBubble = false;
          }, 2000);
        }
      }
    }
  },

  mounted() {
    this.scrollToBottom();
  },

  beforeUnmount() {
    if (this.isRecording) {
      this.stopRecording();
    }
    if (this.recordedAudioUrl) {
      URL.revokeObjectURL(this.recordedAudioUrl);
    }
  }
}
</script>

<style src="./chat.css" scoped></style>